import { DateRangePickerService } from './../date-range-picker.service';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { Day, Month } from '../date-range-picker.service';
import { CommonModule, DatePipe } from '@angular/common';
import { DateFormats } from '@constants/date-format.constants';
import { LetDirective } from '@directives/app-let.directive';
import { FALLBACK_CULTURE } from '@constants/app.constants';

@Component({
  selector: 'app-date-range-picker-month',
  standalone: true,
  imports: [CommonModule, LetDirective, DatePipe],
  templateUrl: './date-range-picker-month.component.html',
  styleUrl: './date-range-picker-month.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateRangePickerMonthComponent {
  @Input() month?: Month | null = null;

  readonly DateFormats = DateFormats;
  readonly FALLBACK_CULTURE = FALLBACK_CULTURE;

  private dateRangePickerService = inject(DateRangePickerService);
  culture$ = this.dateRangePickerService.culture$;
  dayNamesOfWeek$ = this.dateRangePickerService.dayNamesOfWeek$;

  onDayClick(day: Day) {
    this.dateRangePickerService.onDayClick(day);
  }
}
